import styled from "styled-components"
import { ReactComponent as DownIcon } from "../../../images/icons/chevron-down.svg"

type StyledProps = {
  $expanded: boolean
}

export const Arrow = styled(DownIcon)<StyledProps>`
  width: 1.2rem !important;
  margin-left: 1rem;
  transition: transform 0.2s;
  transform: rotate(${(p) => (p.$expanded ? "180deg" : "0deg")});
`

export const ValidateStock = styled.div`
  margin-bottom: 1rem;
  font-weight: 700;
  display: flex;

  i {
    width: 2rem;
  }

  span {
    margin-left: 1rem;
  }
`

export const Tab = styled.div<StyledProps>`
  display: flex;
  align-items: center;
  border-bottom: ${(p) => (p.$expanded ? "none" : `0.1rem solid ${p.theme.colors.greyLight}`)};

  svg {
    width: 1.6rem;
    margin-right: 1rem;
  }

  &:hover {
    cursor: pointer;
    color: ${(p) => p.theme.colors.turquoiseDark};

    svg {
      fill: ${(p) => p.theme.colors.turquoiseDark};
    }
  }
`

export const Container = styled.div`
  background: ${(p) => p.theme.colors.white};
  border-radius: 0.6rem;
  border: 0.1rem solid ${(p) => p.theme.colors.greyLight};
  margin-bottom: 0.8rem;
  padding: 1rem;
`

export const Wrapper = styled.div`
  display: flex;
  align-items: center;
`

export const Dates = styled.div`
  font-size: 1.1rem;
  display: flex;
  justify-content: space-between;
  margin-top: 1rem;
`

export const LoaderContainer = styled.div`
  height: 1.6rem;
  margin-top: 1rem;
`

